export default "__VITE_ASSET__B05qbk6o__"